import React from 'react';
import { Stack, Strong } from '@ovotech/element-v5';
import { formatUtrn } from '@/src/components/payg/utils/formatUtrn';
import { CodeBox } from '@/src/components/payg/CodeBox';

type Props = {
  utrn: string;
};

export const UtrnCode = ({ utrn }: Props) => (
  <Stack spaceBetween={2}>
    <Strong>Top-up code</Strong>
    <CodeBox code={formatUtrn(utrn)} accessibilityLabel="Top-up code" />
  </Stack>
);
